import React from 'react';
import * as Style from '../styles';

function ReportSectionCard({ title, children }) {
    return (
        <Style.SectionCard>
            <Style.SectionHeader>
                <Style.SectionTitle>{title}</Style.SectionTitle>
            </Style.SectionHeader>
            <Style.SectionScroll>{children}</Style.SectionScroll>
        </Style.SectionCard>
    );
}

export default ReportSectionCard;
